"use strict";

define('rs/models/assignments',['rs/models/abstract', 'rs/models/assignment.builder'], function (AbstractModel, AssignmentBuilder) {
  var Assignments = AbstractModel.extend({
    properties: ['map', 'assignments', 'documentId', 'lazyFetch', 'studyId'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      if (this.document) {
        this.setDocumentId(this.document.id);
      }
      if (this.study) {
        this.setStudyId(this.study.id);
      }
    },
    getSponsorsByAssignmentType: function getSponsorsByAssignmentType(type) {
      return this.getAssignmentsByTypeAndField(type, 'sponsor');
    },
    getPersonsByAssignmentType: function getPersonsByAssignmentType(type) {
      return this.getAssignmentsByTypeAndField(type, 'person');
    },
    getGroupsByAssignmentType: function getGroupsByAssignmentType(type) {
      return this.getAssignmentsByTypeAndField(type, 'group');
    },
    getOrganizationsByAssignmentType: function getOrganizationsByAssignmentType(type) {
      return this.getAssignmentsByTypeAndField(type, 'organization');
    },
    getPropertiesByAssignmentType: function getPropertiesByAssignmentType(type) {
      return this.getAssignmentsByTypeAndField(type, 'value');
    },
    getAssignmentsByTypeAndField: function getAssignmentsByTypeAndField(type, field) {
      var plucked = [],
        assignments = this.getAssignmentsByType(type),
        len = assignments ? assignments.length : 0,
        i = 0,
        assignment = null;
      if (!field) {
        return assignments;
      }
      for (i = 0; i < len; ++i) {
        assignment = assignments[i];
        if (assignment && assignment[field]) {
          plucked.push(assignment[field]);
        }
      }
      return plucked;
    },
    getSimpleMap: function getSimpleMap() {
      var assignments = this.getAssignments(),
        map = {},
        len = assignments ? assignments.length : 0,
        assignment = null,
        value = null,
        type = null,
        i = 0;
      for (i = 0; i < len; ++i) {
        assignment = assignments[i];
        type = AssignmentBuilder.getTypeFromAssignment(assignment);
        value = AssignmentBuilder.getObjectFromAssignment(assignment);
        if (value) {
          map[type] = value;
        }
      }
      return map;
    },
    getAll: function getAll(type) {
      return this.getAssignmentsByType(type);
    },
    getOne: function getOne(type, field) {
      return this.getAssignmentsByTypeAndField(type, field)[0] || null;
    },
    getOneByPersonId: function getOneByPersonId(personId) {
      return _.find(this.getAssignments(), function (assignment) {
        var person = assignment.person || {};
        return person.id == personId;
      });
    },
    getOnePerson: function getOnePerson(type) {
      return this.getPersonsByAssignmentType(type)[0];
    },
    getOneProperty: function getOneProperty(type) {
      return this.getPropertiesByAssignmentType(type)[0];
    },
    getOneGroup: function getOneGroup(type) {
      return this.getGroupsByAssignmentType(type)[0];
    },
    getOneOrganization: function getOneOrganization(type) {
      return this.getOrganizationsByAssignmentType(type)[0];
    },
    getAssignmentsByType: function getAssignmentsByType(type) {
      return this.getMap()[type] || [];
    },
    getAssignmentsByPersonId: function getAssignmentsByPersonId(personId) {
      return _.filter(this.getAssignments(), function (assignment) {
        if (assignment.person) {
          return assignment.person.id == personId;
        } else {
          return false;
        }
      });
    },
    hasAssignment: function hasAssignment(type) {
      return !_.isEmpty(this.getAssignmentsByType(type));
    },
    personHasAssignment: function personHasAssignment(assignmentType, personId) {
      var assignments = this.getAssignmentsByPersonId(personId);
      return !!_.find(assignments, function (assignment) {
        return assignment.assignmentType && assignment.assignmentType.description == assignmentType;
      });
    },
    setup: function setup() {
      return Promise.bind(this).then(function () {
        return AssignmentBuilder.requestAssignmentTypes();
      }).then(function () {
        if (!this.lazyFetch) {
          if (this.getDocumentId()) {
            return AssignmentBuilder.requestAssignments(this.getDocumentId()).bind(this).tap(this.setAssignments);
          }
          if (this.getStudyId()) {
            return AssignmentBuilder.requestStudyAssignments(this.getStudyId()).bind(this).tap(this.setAssignments);
          }
        } else if (!this.getAssignments()) {
          this.setAssignments([]);
        }
      });
    },
    setAssignments: function setAssignments(assignments) {
      this.setMap(AssignmentBuilder.createAssignmentMap(assignments));
      return this._super.apply(this, arguments);
    },
    build: function build() {
      return this.constructor.build({
        document: this.document,
        study: this.study
      });
    }
  }, {
    build: function build(properties) {
      return new AssignmentBuilder(properties);
    },
    requestAll: function requestAll(properties) {
      var assignments = new this(properties);
      return assignments.setup().thenReturn(assignments);
    }
  });
  return Assignments;
});

